export const muiSelectTheme = {
  MuiSelect: {
    styleOverrides: {
      root: ({ theme }) => ({
        '.MuiInput-input': {
          fontFamily: 'Inter',
          fontSize: '14px',
          lineHeight: '21px',
          color: theme.palette.kit.text.secondary,
          '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            background: 'transparent',
            width: '7px',
            height: '7px',
            borderTop: `1.5px solid ${theme.palette.kit.text.main}`,
            borderLeft: `1.5px solid ${theme.palette.kit.text.main}`,
            borderBottom: 'none !important',
            transformOrigin: 'center',
            transition: '.4s',
            bottom: '15px',
            right: '5px',
            left: 'unset',
            transform: 'rotate(-135deg) translateY(0)',
          },
          '&[aria-expanded=true]::after': {
            transform: 'rotate(45deg) translateY(2px)',
          },
        },
        '& .MuiSvgIcon-root': {
          display: 'none',
        },
        '&::after': {
          display: 'none',
        },
        '&.Mui-focusVisible': {
          background: 'none',
          '&::before': {
            borderBottom: `1px solid ${theme.palette.kit.accent} !important`,
          },
        },
        '&:hover:not(.Mui-disabled)': {
          background: 'none',
          '&::before': {
            borderBottom: `1px solid ${theme.palette.kit.accent} !important`,
          },
        },
        '& .MuiList-root': {
          padding: '12px 8px',
        },
        marginBottom: '0px !important',
        color: theme.palette.kit.text.main,
        background: 'none !important',
        paddingLeft: 0,
        paddingBottom: 0,
        paddingTop: 0,
        position: 'relative',
        '& *': {
          background: 'none !important',
        },
      }),
    },
  },
};
